/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect, useCallback } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { distributorService } from '../../service/distributor.service';
import ShippingOrganizationSkeleton from './ShippingOrganizationsSkeleton';
import EmptyScreen from '../../Components/GlobalEmplyPage';
import Pagination from '../../Components/Pagination';

function ShippingOrganizations() {
    const [threepllocations, setThreepllocations] = useState([]);
    const [searchValue, setsearchValue] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState('');
    const [sortType, setsortType] = useState('ORGANIZATION_NAME+desc');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [alldata, setalldata] = useState({});

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(searchValue);
            setCurrentPage(1);
        }, 500);
        return () => clearTimeout(timer);
    }, [searchValue]);

    const getThreepl = useCallback(((page) => {
        const latestPage = page || currentPage;
        setLoading(true);
        distributorService.shippingOrganizationLocations(latestPage, sortType, status, debouncedSearch).then((res) => {
            if (res.data.success_status === true) {
                setThreepllocations(res.data.Items);
                setTotalPage(res.data.number_of_pages);
                setalldata(res.data);
            }
            setLoading(false);
        });
    }), [currentPage, sortType, status, debouncedSearch]);

    const handlePageClick = (data) => {
        const page = data.selected + 1;
        setCurrentPage(page);
        getThreepl(page);
    };

    const handleFilter = async (data) => {
        setCurrentPage(1);
        setStatus(data);
    };

    useEffect(() => {
        getThreepl();
    }, [getThreepl]);

    return (
        <div className="py-6">
            <div className="flex justify-between sticky top-0 left-0">
                <h5 className="text-xs4 font-normal text-[#090406]">Shipping Organizations (3PLs)</h5>
                <div className="flex">
                    <div className="relative">
                        <label htmlFor="search" />
                        <input
                            type="text"
                            name="search"
                            id="search"
                            className="w-[235px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]"
                            placeholder="Search"
                            value={searchValue}
                            onChange={(e) => {
                                setsearchValue(e.target.value);
                            }}
                        />
                        <img src="images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px]" />
                    </div>
                </div>
            </div>
            <div className="flex justify-end pt-[22px] items-center pb-[10px]">
                <p className="text-xs2 font-normal text-[#989898] pr-[15px]">Status</p>
                <ul className="w-[230px] h-[35px] border border-[#555259] rounded-lg nav nav-pills flex items-center justify-evenly" id="pills-tab" role="tablist">
                    <li className="nav-item w-1/3 text-center" role="presentation">
                        <a
                            href="#pills-all"
                            className={`nav-link block ${status === '' ? 'active' : ''} text-xs2 font-semibold text-[#555259] all`}
                            id="pills-all-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-all"
                            role="tab"
                            aria-controls="pills-all"
                            aria-selected="true"
                            onClick={() => { handleFilter(''); }}
                        >
                            All
                        </a>
                    </li>
                    <li className="nav-item w-1/3 text-center" role="presentation">
                        <a
                            href="#pills-active"
                            className={`nav-link block ${status === 'Y' ? 'active' : ''} text-xs2 font-semibold text-[#555259] all`}
                            id="pills-home-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-home"
                            role="tab"
                            aria-controls="pills-home"
                            aria-selected="false"
                            onClick={() => { handleFilter('Y'); }}
                        >
                            Active
                        </a>
                    </li>
                    <li className="nav-item w-1/3 text-center" role="presentation">
                        <a
                            href="#pills-inactive"
                            className={`nav-link block ${status === 'N' ? 'active' : ''} text-xs2 font-semibold text-[#555259] all`}
                            id="pills-home-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-inactive"
                            role="tab"
                            aria-controls="pills-inactive"
                            aria-selected="false"
                            onClick={() => { handleFilter('N'); }}
                        >
                            Inactive
                        </a>
                    </li>
                </ul>
            </div>
            {loading ? <ShippingOrganizationSkeleton />
                : (
                    <div>
                        {threepllocations?.length > 0
                            && (
                                <div
                                    className="overflow-auto dropdown-menu pb-7 relative z-0"
                                    style={{ height: 'calc(100vh - 345px)' }}
                                >
                                    <table className="w-full table-auto relative">
                                        <thead className="top-0 left-0 sticky z-[2]">
                                            <tr className="bg-[#555259] h-10">
                                                <th scope="col" className="py-3 px-7  min-w-[152px] rounded-bl-lg rounded-tl-lg ">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        Plant Name
                                                        <a href="#" className="pl-[5px]">
                                                            <motion.img
                                                                animate={{
                                                                    rotate: sortType === 'ORGANIZATION_NAME+asc' ? 180 : 0,
                                                                }}
                                                                className={`${sortType === 'ORGANIZATION_NAME' ? 'image-rotate' : ''}`}
                                                                src="/images/sort.svg"
                                                                alt="icon"
                                                                onClick={() => {
                                                                    setCurrentPage(1);
                                                                    if (sortType === 'ORGANIZATION_NAME+asc') {
                                                                        setsortType('ORGANIZATION_NAME+desc');
                                                                    } else if (sortType === 'ORGANIZATION_NAME+desc') {
                                                                        setsortType('ORGANIZATION_NAME+asc');
                                                                    } else { setsortType('ORGANIZATION_NAME+asc'); }
                                                                }}
                                                            />
                                                        </a>
                                                    </span>
                                                </th>
                                                <th className="py-3 px-6 min-w-[158px] bg-[#555259]" scope="col">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                        Plant Location
                                                    </span>
                                                </th>
                                                <th className="py-3 px-6 min-w-[158px] bg-[#555259] text-left" scope="col">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                        Plant Description
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-3 px-7 min-w-[140px] rounded-tr-lg rounded-br-lg">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        Status
                                                        <a href="#" className="pl-[5px]">
                                                            <motion.img
                                                                animate={{
                                                                    rotate: sortType === 'IS_ACTIVE_FLAG+asc' ? 180 : 0,
                                                                }}
                                                                className={`${sortType === 'IS_ACTIVE_FLAG' ? 'image-rotate' : ''}`}
                                                                src="/images/sort.svg"
                                                                alt="icon"
                                                                onClick={() => {
                                                                    setCurrentPage(1);
                                                                    if (sortType === 'IS_ACTIVE_FLAG+asc') {
                                                                        setsortType('IS_ACTIVE_FLAG+desc');
                                                                    } else if (sortType === 'IS_ACTIVE_FLAG+desc') {
                                                                        setsortType('IS_ACTIVE_FLAG+asc');
                                                                    } else { setsortType('IS_ACTIVE_FLAG+asc'); }
                                                                }}
                                                            />
                                                        </a>
                                                    </span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {threepllocations.map((item) => (
                                                <tr className="bg-[#FDFDFE] border-b border-[#DFEAF7]">
                                                    <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                                        {item.ORGANIZATION_NAME}
                                                    </td>
                                                    <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                        {item.CITY}
                                                    </td>
                                                    <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                                        {item.DESCRIPTION}
                                                    </td>
                                                    {item.IS_ACTIVE_FLAG === 'Y'
                                                        ? (
                                                            <td className="text-xs font-normal py-2.5 px-7 text-center">
                                                                <a
                                                                    href="#"
                                                                    className="flex rounded-sm border-2 border-[#D7F8DC] bg-[#D7F8DC] py-0.5 pr-1.5 w-fit"
                                                                >
                                                                    <img src="images/Active-icon.svg" alt="icon" className="px-2" />
                                                                    Active
                                                                </a>
                                                            </td>
                                                        ) : (
                                                            <td className="text-xs font-normal py-2.5 px-7 text-center">
                                                                <a href="#" className="flex rounded-sm border-2 border-[#B9BDC3] bg-[#B9BDC3] text-[#FFFFFF] py-0.5 pr-1.5 w-fit">
                                                                    <img src="images/inactive-1.svg" alt="icon" className="px-2" />
                                                                    Inctive
                                                                </a>
                                                            </td>
                                                        )}
                                                </tr>
                                            ))}
                                            <tr className="h-1" />
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        {!loading && threepllocations.length > 0 && (
                            <Pagination
                                handlePageClick={handlePageClick}
                                List={alldata}
                                currentPage={currentPage}
                                totalPage={totalPage}
                            />
                        )}
                    </div>
                )}

            {!loading && threepllocations.length === 0
            && <EmptyScreen search="yes" text="No Shipping Organizations" all={debouncedSearch.length > 0 ? 'under searched term' : 'found'} />}
        </div>
    );
}

export default ShippingOrganizations;
